import React, { FC, useMemo } from 'react';
import { DashboardDeviceData } from '../interfaces';
import { ActivityIcon, Card, DataOverView } from '@Iot-Bee/standard-web-library';

interface DashboardOverviewProps {
  devicesData: DashboardDeviceData[];
  isLoading: boolean;
  deviceCount: number;
}

const DashboardOverview: FC<DashboardOverviewProps> = ({ devicesData, isLoading, deviceCount }) => {
  //Estimating that we save them 40%
  const totalKwHInTimePeriod = useMemo(() => {
    return devicesData.reduce((acc, d) => {
      let deviceSum = 0;
      d.data.forEach((datapoint) => {
        deviceSum += datapoint.value;
      });
      return acc + deviceSum;
    }, 0);
  }, [devicesData]);
  const cO2AmountPerKWH = 0.132;

  const dataOverviewItems = [
    {
      title: 'Active devices',
      value: deviceCount,
      icon: <ActivityIcon />,
    },
    {
      title: 'Total kWh consumption',
      value:
        String(
          devicesData.reduce((acc, item) => acc + item.data.reduce((res, data) => res + data.value, 0), 0).toFixed(0)
        ) + ' kWh',
    },
    {
      title: 'Estimated CO2 consumption',
      value: String((totalKwHInTimePeriod * cO2AmountPerKWH).toFixed(0)) + ' Kg',
    },
  ];

  return (
    <Card title="Overview">
      <DataOverView data={dataOverviewItems} isLoading={isLoading} />
    </Card>
  );
};

export default DashboardOverview;
